
import 'normalize.css'
import vConsole from 'vconsole'
import env from '@/core/utils/env'
import { getUserInfo } from '@/core/jsapi'
import request from '@/core/request'
import { auth } from '@/core/api'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'LayoutDefault',
  setup() {
    const debug = ref(false)
    const store = useStore()

    const loadUserInfo = () => {
      request(auth).then(res => {
        const { code, data } = res
        if (!code) {
          store.commit('setIsLogin', true)
          store.commit('setCoin', data.jinbi)
          store.commit('setRedpack', data.redpack)
          store.commit('setUserInfo', data)
        }
      })
    }

    const loadClientInfo = async () => {
      getUserInfo().then((data: any) => {
        store.commit('setUserInfo', {
          nick: data.name,
          // eslint-disable-next-line @typescript-eslint/camelcase
          face_url: data.icon
        })
      })
    }

    onMounted(() => {
      const { documentElement } = document
      console.log(
        `current page width: ${documentElement.clientWidth}, current page height: ${documentElement.clientHeight}, dpr=${window.devicePixelRatio}`
      )
      if (env === 'testing' || env === 'pre') {
        // eslint-disable-next-line new-cap
        // new vConsole()
        debug.value = true
      }
      loadUserInfo()
      loadClientInfo()
    })

    return {
      env,
      debug
    }
  }
}
